import { render, staticRenderFns } from "./IndentDate.vue?vue&type=template&id=ed4a6128&scoped=true"
import script from "./IndentDate.vue?vue&type=script&lang=js"
export * from "./IndentDate.vue?vue&type=script&lang=js"
import style0 from "./IndentDate.vue?vue&type=style&index=0&id=ed4a6128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4a6128",
  null
  
)

export default component.exports